import styled from 'styled-components';

interface IPointer {
  rotate: number;
}

export const Score = styled.div<IPointer>`
  font-family: 'Roboto';

  p {
    color: #525252;
  }

  .emogi {
    width: 103px;
    height: 103px;
  }

  .scale {
    width: 91px;
    height: 45px;
  }

  .divPointer {
    position: absolute;
    width: 26px;
    top: 27px;
    left: calc(50% - 13px);
    transform: rotate(${(props) => props.rotate}deg);
  }

  .pointer {
    //width: 26px;
    height: 16px;
  }
`;
